class Detalhes {

    div = false
    divInterna = false
    body = false
    trigger = false
    buttonClose = false
    teste = false
    handleOut = null

    constructor() {

        this.trigger = document.querySelector('button.detalhes-button')
        if (!this.trigger) return;

        this.div = document.createElement('div')
        this.div.classList.add("more-details")

        this.divInterna = document.createElement('div')
        this.div.appendChild(this.divInterna)

        this.buttonClose = document.querySelector('button.close').cloneNode(true)
        this.divInterna.appendChild(this.buttonClose)

        this.content = document.querySelector('div.texts-summy').cloneNode(true)
        this.divInterna.appendChild(this.content)

        this.body = document.body
        this.body.appendChild(this.div)

        this.trigger.addEventListener('click', (event) => {

            event.preventDefault()
            if (this.div.classList.contains('opened')) {
                this.close()
            }
            else {
                this.open()
            }

        })

        // Close button
        this.buttonClose.addEventListener('click', (event) => {
            event.preventDefault()
            this.close()
        })

    }

    open() {

        this.div.classList.add('opened')
        this.trigger.classList.add('opened')
        Piki.lockScroll()

    }

    close() {

        this.div.classList.remove('opened')
        this.trigger.classList.remove('opened')
        Piki.unlockScroll()

    }

}

window.addEventListener('DOMContentLoaded', () => {
    new Detalhes()
});